import React, { useEffect, useRef } from "react";
import type { MenuCategory } from "@/constants/Menu";

export const NavbarSubmenu: React.FC<{
  category: MenuCategory;
}> = ({ category }) => {
  const detailsRef = useRef<HTMLDetailsElement>(null);

  useEffect(() => {
    const closeSubmenu = (event: MouseEvent) => {
      if (
        detailsRef.current !== null &&
        event.target instanceof Node &&
        !detailsRef.current.contains(event.target)
      ) {
        detailsRef.current.open = false;
      }
    };

    document.addEventListener("click", closeSubmenu);
    return () => document.removeEventListener("click", closeSubmenu);
  }, []);

  return (
    <li className="relative">
      <details ref={detailsRef} name="main-navigation" className="group">
        <summary className="flex cursor-pointer list-none items-center rounded-lg px-2 py-1 hover:bg-primary-50 hover:text-primary-500 [&::-webkit-details-marker]:hidden">
          {category.title}
          <span aria-hidden="true" className="ml-1 text-xs">
            ▾
          </span>
        </summary>
        <ul className="mt-1 space-y-1 rounded-xl border border-primary-100 bg-white p-2 shadow-sm md:absolute md:right-0 md:z-10 md:min-w-56">
          {category.items.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="block rounded-lg px-3 py-2 text-sm text-primary-700 hover:bg-primary-50 hover:text-primary-500"
              >
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      </details>
    </li>
  );
};
